import React, { useEffect, useState } from 'react';
import css from './modal.module.scss';
import { EditTemplateName } from './edit-template-name';
import { AddCategoryButton } from './add-tag';
import {
	IWorkshopTemplateBase,
} from '../../../../../entities/template/workshop/template/model/types';
import { NewModal } from '../../../../../components/ui/modals/new-modal';
import { ChangeableTagList } from '../../../../../widgets/changeable-tag-bar/ui/tag-list/changeable-tag-list';
import {
	ComponentEditorStructureVisualizer,
} from '../../../../../shared/libs/EditorManipulators/editors/EditorStructureVisualizer';
import {
	IntegratorPanelTemplateControls,
} from '../../../../../components/pages/integrator-panel/template/ui/controls/controls';
import { IntegrateWorkshopTemplateModal } from '../../integrate-in-account/ui/integrate-workshop-template-modal';
import {
	ChangeWorkshopTemplateModal
} from '../../../../../components/pages/integrator-panel/template/ui/modal/change-workshop-templates-modal/change-workshop-templates-modal';
import { useAppSelector } from '../../../../../shared/libs/redux';
import { workshopTemplateSlice } from '../../../../../entities/template/workshop/template/model/slice';

interface ITemplateInfoModalProps {
	isActive: boolean,
	onClose: () => void,
	editName: (name: string) => Promise<void>,
	data: IWorkshopTemplateBase,
	unbindCategory: (category: number) => void,
	onDuplicate: () => void,
	isPDFAvailable: boolean,
}

export const WorkshopTemplateInfoModal = (props: ITemplateInfoModalProps) => {
	const {
		isActive,
		onClose,
		editName,
		unbindCategory,
		data,
		onDuplicate,
		isPDFAvailable,
	} = props;
	const { template, rootComponent } = data;
	const { name, categories } = template;

	const [isSelectUserModalActive, setIsSelectUserModalActive] = useState(false);
	const [isChangeModalActive, setIsChangeModalActive] = useState(false);
	const isPublishModalActive = useAppSelector(workshopTemplateSlice.selectors.getIsDuplicateModalActive);

	return (
		<NewModal
			styles={css.wrapper}
			active={isActive}
			closeFunc={onClose}
			modalInModalActive={
				isSelectUserModalActive
				|| isChangeModalActive
				|| isPublishModalActive
			}
		>
			<div className={css.preview}>
				<ComponentEditorStructureVisualizer structure={{
					id: template.id,
					name: template.name,
					root: rootComponent,
				}}
				/>
			</div>
			<div className={css.options}>
				<EditTemplateName editName={editName} name={name} />

				<div className={css.tags}>
					<p className={css.title}>Категории</p>
					{(!categories.fromTemplates || categories.fromTemplates.length === 0) ? (
						<p>Отсутствуют</p>
					) : (
						<ChangeableTagList
							deleteTag={unbindCategory}
							activeTags={categories.fromTemplates}
							disabledTags={categories.fromModules}
						/>
					)}
					<AddCategoryButton onChange={() => setIsChangeModalActive(true)} />
				</div>

				<div className={css.buttons}>
					<IntegratorPanelTemplateControls
						template={data}
						onDuplicate={onDuplicate}
						onClose={onClose}
						openPublishModal={() => setIsSelectUserModalActive(true)}
					/>
					{!isPDFAvailable && (
						<span className={css.unavailableText}>Недоступно в пробной версии</span>
					)}
				</div>
			</div>
			<IntegrateWorkshopTemplateModal
				isActive={isSelectUserModalActive}
				setActive={setIsSelectUserModalActive}
				template={template?.id || ''}
			/>
			<ChangeWorkshopTemplateModal
				template={data}
				isActive={isChangeModalActive}
				setActive={setIsChangeModalActive}
			/>
		</NewModal>
	);
};
